import { FC, useMemo } from 'react';
import { IS_TIGER_SELF } from 'utils/constants';

interface DebugProps {
    data: object;
    title?: string;
    disabled?: boolean;
}

const Debug: FC<DebugProps> = ({ title = 'Debug', data, disabled }) => {
    const showData = useMemo(() => {
        try {
            return JSON.stringify(data, null, 2);
        } catch {}

        return String(data);
    }, [data]);

    return __DEV__ && !disabled && !IS_TIGER_SELF ? (
        <pre className="my-4">
            <h4>{title}：</h4>
            {showData}
        </pre>
    ) : null;
};

export default Debug;
